import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import {Office} from "./interfaces";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

interface BasicTabProps {
    offices: Office[];
}

export default function OfficeVersionTabs(props: BasicTabProps) {
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                  sx={{ padding: 2 }}
                >
                    {props.offices.map((office, index) =>
                      <Tab
                        key={index}
                        sx={{ color: 'white', fontSize: "1rem", fontWeight: 400 }}
                        label={`Office ${office.officeVersion}`}
                        {...a11yProps(index)}
                      />
                    )}
                </Tabs>
            </Box>
            {props.offices.map((office, index) => (
                <TabPanel value={value} index={index} key={index}>
                    <Box display="flex" paddingY={8}>
                        <Box display="flex" flex={1} justifyContent="center" alignItems="center">
                            <Box display="flex" flexDirection="column">
                                <Typography fontSize="1.25rem" lineHeight="32px">Microsoft</Typography>
                                <Box display="flex" alignItems="flex-end">
                                    <Typography fontSize="2.75rem" lineHeight="52px">Office</Typography>
                                    <Typography fontSize="1.5rem" marginLeft={1}>{office.officeVersion}</Typography>
                                </Box>
                            </Box>
                        </Box>
                        <Box display="flex" flex={2} flexDirection="column">
                            <Typography fontSize="1.25rem" lineHeight="32px">
                                Download one of these packages if you have Office {office.officeVersion} installed in your system.
                            </Typography>
                            <Stack spacing={3} direction="row" paddingTop={5}>
                                <a href={office.url32}>
                                    <Button
                                      variant="contained"
                                      startIcon={<CloudDownloadIcon/>}
                                      sx={{ bgcolor: '#2251ff', borderRadius: 0 }}
                                    >
                                        32-bits
                                    </Button>
                                </a>
                                <a href={office.url64}>
                                    <Button
                                      variant="contained"
                                      startIcon={<CloudDownloadIcon/>}
                                      sx={{ bgcolor: '#2251ff', borderRadius: 0 }}
                                    >
                                        64-bits
                                    </Button>
                                </a>
                            </Stack>
                        </Box>
                    </Box>
                </TabPanel>)
            )}
        </Box>
    );
}
